import {isExpired, decodeToken} from 'react-jwt'

interface JwtPayload {
    exp?: number;
    [key: string]: any;
}

export const getJwtHelper = () => {
    const storedIdToken = localStorage.getItem('selfServiceIdToken');
    
    if (storedIdToken) {
        return storedIdToken;
    }
    
    return undefined;
}

export const isJwtExpired = (jwt: string) => {
    return isExpired(jwt);
}

export const isJwtExpiringSoon = (jwt: string, bufferMinutes: number = 5): boolean => {
    try {
        const decoded = decodeToken(jwt) as JwtPayload;
        if (!decoded?.exp) return true;
        
        const expirationTime = decoded.exp * 1000;
        const bufferTime = bufferMinutes * 60 * 1000;
        return Date.now() >= (expirationTime - bufferTime);
    } catch {
        return true;
    }
}
